module.exports = __webpack_public_path__ + "static/kvm_13.b501a6ff.png";